import { styled, ButtonBase } from '@mui/material';

const IconicRideCard = styled(ButtonBase)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  alignItems: 'flex-start',
  gap: theme.spacing(3),
  '& .IRCImgContainer': {
    height: theme.typography.pxToRem(635),
    width: '100%',
    borderRadius: theme.spacing(0.5),
    overflow: 'hidden',
    [theme.breakpoints.down('xl')]: {
      height: theme.typography.pxToRem(404),
    },
    [theme.breakpoints.down('lg')]: {
      height: theme.typography.pxToRem(381),
    },
    [theme.breakpoints.down('md')]: {
      height: theme.typography.pxToRem(370),
    },
  },
  '& .TCSubTitle': {
    color: theme.palette.text.secondary,
  },
}));
export default IconicRideCard;
